module.exports = ".edit-manageportfolio .edit-select-companies /deep/ .dropdown {\n  display: block;\n  margin-top: 10px;\n}\n.edit-manageportfolio .edit-administer-btn {\n  margin: 25px 2px 2px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/manageportfolio/manageportfolio.less
// module id = ./src/app/management/components/manageportfolio/manageportfolio.less
// module chunks = main